/*=========================================================================================
  File Name: i18n.js
  Description: i18n configuration file. Imports i18n data.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import i18nData from './i18nData';
import Translations from '../../vue-i18n-locales.generated';

Vue.use(VueI18n);

Object.keys(Translations).forEach(function (lang) {
    Object.keys(Translations[lang]).forEach(function (trans) {
        if (i18nData[lang] === undefined) {
            Vue.set(i18nData, lang, Translations[lang]);
        } else {
            Vue.set(i18nData[lang], trans, Translations[lang][trans]);
        }
    });
});

export default new VueI18n({
    fallbackLocale: 'en',
    locale: 'en', // set default locale
    messages: i18nData,
});
